<script lang="ts">
    import type { InfoPopupDefinition, PortletDebugInformation } from 'header/types';
    import { MailingService } from 'portlet/services';

    interface Props {
        definition: InfoPopupDefinition;
    }

    let { definition }: Props = $props();

    function addNavigationData(debugInfo: PortletDebugInformation) {
        return {
            ...debugInfo,
            userInfo: {
                ...debugInfo.userInfo,
                value: {
                    ...debugInfo.userInfo.value,
                    'browser info': navigator.userAgent || navigator.appVersion,
                    'operating system':
                        (navigator as any).userAgentData?.platform || navigator.platform,
                    url: location.href,
                },
            },
        };
    }

    function getPortletInfo(debugInfo: PortletDebugInformation) {
        return { PID: debugInfo.portletInfo?.value?.pid, 'Query ID': debugInfo.query?.value?.id };
    }
    let debugPortletInfo = $derived(getPortletInfo(definition.debugInfo));
    let debugInfoRaw = $derived(addNavigationData(definition.debugInfo));
    let debugInfoHTML = $derived(MailingService.convertDebugDataToHTML(debugInfoRaw));
</script>

<div class="info">
    <table class="debug-data">
        <tbody>
            {#each Object.entries(debugPortletInfo) as [key, value]}
                <tr>
                    <td>{key}</td>
                    <td>{value}</td>
                </tr>
            {/each}
        </tbody>
    </table>
    <details class="info__item--full-grid">
        <summary>Debug data</summary>
        <div class="info__debug">
            {@html debugInfoHTML}
        </div>
    </details>
</div>

<style lang="scss" scoped>
    .debug-data {
        grid-column: 1/3;
    }

    .info {
        display: grid;
        grid-template-columns: 75px 1fr;
        row-gap: 1rem;

        &__item {
            &--full-grid {
                grid-column: 1 / 3;
            }
        }

        &__debug {
            &:focus-visible {
                outline: none;
            }
        }

        :global(.debug-data) {
            border-collapse: collapse;
            width: 100%;
            :global(td) {
                padding: 0.2rem;
                border: 1px solid #808080;
            }
        }
    }
</style>
